import {
    O365_LOAD_EVENTS_REQUEST,
    O365_LOAD_EVENTS_SUCCESS,

    CORE_CHECKIN_REQUEST,
    CORE_CHECKIN_SUCCESS,

    CORE_CHECKOUT_REQUEST,
    CORE_CHECKOUT_SUCCESS,

    CORE_DELETE_EVENT_REQUEST,
    CORE_DELETE_EVENT_SUCCESS,
} from '../../types'

const initialState = []
export default {
    events: (state = initialState, action) => {
        switch (action.type) {
            case O365_LOAD_EVENTS_REQUEST:
                return []

            case O365_LOAD_EVENTS_SUCCESS:
                let eventList = []
                if (Array.isArray(action.payload)) {
                    eventList = action.payload
                }
                return eventList
            default:
                return state
        }
    },
    checkIn: (state = false, action) => {
        switch (action.type) {
            case CORE_CHECKIN_REQUEST:
                return false

            case CORE_CHECKIN_SUCCESS:
                return true

            default:
                return state
        }
    },
    checkOut: (state = false, action) => {
        switch (action.type) {
            case CORE_CHECKOUT_REQUEST:
                return false

            case CORE_CHECKOUT_SUCCESS:
                return true

            default:
                return state
        }
    },
    deleteEvent: (state = false, action) => {
        switch (action.type) {
            case CORE_DELETE_EVENT_REQUEST:
                return false

            case CORE_DELETE_EVENT_SUCCESS:
                return true

            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/events/reducer.js